<atn-ds-page>
  <atn-ds-table [config]="tableConfig">
    <ng-container customTools>
      <!-- Uncomment once filters for reports are ready -->
      <!-- <i
        class="atn-icon atn-funnel atn-blue"
        (click)="filterButtonClickHandler()"
      ></i> -->
    </ng-container>
  </atn-ds-table>
</atn-ds-page>

@if (showFilterSlideout) {
  <atn-ds-slideout-overlay
    title="Filters"
    [hasFullHeight]="false"
    (backdropClicked)="slideoutBackdropClickHandler()"
  >
    <i
      class="atn-icon atn-close atn-red"
      actions
      (click)="slideoutCloseBtnClickHandler()"
    ></i>
    <atn-filter-slideout />
  </atn-ds-slideout-overlay>
}
